$("body.in-index .products-block").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: { slidesToShow: 3, slidesToScroll: 1 },
        },
        {
            breakpoint: 991,
            settings: { slidesToShow: 2, slidesToScroll: 1 },
        },
        {
            breakpoint: 550,
            settings: {
                slidesToShow: 1,
                variableWidth: true,
            }
        },

    ],
});


function initUspsSlider() {
    const $slider = $('.usps .container');

    if (!$slider.length) return;

    if (window.innerWidth <= 767) {
        if (!$slider.hasClass('slick-initialized')) {
            $slider.slick({
                variableWidth: true,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 5000,
                cssEase: 'linear',
                arrows: false,
                dots: false,
                draggable: true,
                swipe: true,
                swipeToSlide: true,
                touchMove: true,
                pauseOnHover: false,
                pauseOnFocus: false
            });
        }
    } else if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
    }
}

$(function () {
    initUspsSlider();
});

let uspsResizeTimer;

$(window).on('resize.uspsSlider', function () {
    clearTimeout(uspsResizeTimer);

    uspsResizeTimer = setTimeout(function () {
        initUspsSlider();
    }, 150);
});